import { render, staticRenderFns } from "./Hour.vue?vue&type=template&id=99bce964"
import script from "./Hour.vue?vue&type=script&lang=js"
export * from "./Hour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99bce964')) {
      api.createRecord('99bce964', component.options)
    } else {
      api.reload('99bce964', component.options)
    }
    module.hot.accept("./Hour.vue?vue&type=template&id=99bce964", function () {
      api.rerender('99bce964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Hour.vue"
export default component.exports